import { UpiAccountTypes } from 'constants/upiConstants';
import { IObjectType } from 'utils/classNames';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare global {
	interface Window {
		onReactivateStatusFetchedSuccessfully: (state: string, status: boolean) => void;
		onReactivateStatusFetchFailed: (error: string, errorCode: string) => void;
		onSDKInitialised: (success: boolean, profileId: string) => unknown;
		onInitSdkStatusUpdated: (state: string, error: string, errorCode: string) => unknown;
		onDeviceBindStatusFetchedSuccessfully: (...args: any[]) => void;
		onDeviceBindStatusFetchFailed: (error: string, errorCode: string) => void;
		onProfileDetailsFetchedSuccessfully: (profileDetails: string) => unknown;
		onProfileDetailsFetchFailed: (error: string, errorCode: string) => void;
		onListOfBanksFetchedSuccessfully: (data: unknown) => void;
		onListOfBanksFetchFailed: (error: string, errorCode: string) => void;
		onListOfAccountsFetchedSuccessfully: (success: boolean, accountData: any) => void;
		onListOfAccountsFetchFailed: (error: string, errorCode: string) => void;
		onAccountAddedSuccessfully: (success: boolean) => void;
		onAccountAddFailed: (error: string, errorCode: string) => void;
		callbackCheckBalanceSuccess: (amount: string) => void;
		callbackCheckBalanceFailed: (error: string, errorCode: string) => void;
		callbackReclaimSuccess: () => void;
		callbackReclaimFailed: (error: string, errorCode: string) => void;
		callbackForgetPinSuccess: () => void;
		callbackForgetPinFailed: (error: string, errorCode: string) => void;
		callbackChangePinSuccess: () => void;
		callbackChangePinFailed: (error: string, errorCode: string) => void;
		callbackRemoveAccountSuccess: () => void;
		callbackRemoveAccountFailed: (error: string, errorCode: string) => void;
		callbackCLRequestSubmitted: (txnDetails: string, error: string, errorCode: string) => void;
		callbackUPIWrapperSuccess: (response: string) => void;
		callbackUPIWrapperFailed: (error: string, errorCode: string) => void;
		callbackRaiseComplaintSuccess: (response: string) => void;
		callbackRaiseComplaintFailed: (error: string, errorCode: string) => void;
		callbackMandateSuccess: (details: string) => void;
		callbackMandateFailed: (error: string, errorCode: string) => void;
		callbackGetBindedMobileSuccess: (mobile: string) => void;
		callbackGetBindedMobileFailed: (error: string, errorCode: string) => void;
		callbackCollectAuthSuccess: (mobile: string) => void;
		callbackCollectAuthFailed: (txnID: string, error: string, errorCode: string) => void;
		callbackGetPendingCollectAPISuccess: (mobile: string) => void;
		callbackGetPendingCollectAPIFailed: (error: string, errorCode: string) => void;
		callbackDelinkUserSuccess: () => void;
		callbackDelinkUserFailed: (error: string, errorCode: string) => void;
	}
}

export interface IHomeModalVisibility {
	accountBreakupModal: boolean;
	prePaidAccountBreakupModal: boolean;
	accountBlockedModal: boolean;
	settingsModal: boolean;
	blockingModal: boolean;
	nonBharatPeModal: boolean;
	notAcceptedQRModal: boolean;
	postpeNotAcceptedModal: boolean;
	freezeAccountModal: boolean;
	riskyAccountBlockModal: boolean;
	accountPermanenetlyBlockedModal: boolean;
	upgradeInProgressModal: boolean;
	upiIntroModal: boolean;
	upiSimModal: boolean;
	upiNoSimModal: boolean;
	disableQrModal: boolean;
	qrUpiSimBindingModal: boolean;
	qrScannerPermissionsModal: boolean;
	qrErrorModal: boolean;
	deregisterProfileAccountModal: boolean;
	importantCheckpointModal: boolean;
	maxLimitModal: boolean;
	debitCardModal: boolean;
	somethingWentWrong: boolean;
	hookPermissionModal: boolean;
	permissionModal: {
		visible: boolean;
		primaryBtnText: string;
	};
}

export interface ITransactionPayload {
	gatewayCreds: any;
	gatewayName: string;
	accountNumber: string;
	amount: string;
	amountRule: string;
	blockFund: string;
	startDate: string;
	endDate: string;
	frequency: string;
	mandateName: string;
	note: string;
	payeeName: string;
	payeeVpa: string;
	revokeable: string;
	mandateId: string;
	transactionRequestId: string;
	orderId: string;
}
export interface IUpiStep {
	upiStep: string;
	upiErr: string;
	loading: boolean;
}

export interface ISimDetailsObject {
	sim_id: string;
	carrier_name: string;
	slot: number;
	phone: string;
	opt_type: string;
	is_active: string;
	icon_res: number;
	icon_bitmap: any;
}

export interface IUpiProfileDetails {
	user_banks: IUserBank[];
	reclaimStatus: boolean;
}

export interface IUserBank {
	'reg-mob-format': string;
	mmid: string;
	va: string;
	'default-debit': any;
	'aadhar-otp': any;
	aadhaarNo: string;
	mbeba: string;
	aeba: string;
	'merchant-genre': any;
	'acc-provider-id': number;
	accRefNumber: string;
	name: any;
	CredsAllowed: IObjectType;
	ifsc: string;
	accType: string;
	'default-credit': any;
	account: string;
	status: string;
	'onboarding-type': any;
	bank_logo: any;
	'acc-provider-name': string;
	is_primary: boolean;
	bank_account_id: string;
	['global-start-date']?: string;
	['']?: string;
	['allow-global-txn']?: 'Y' | 'N';
	account_identifier: UpiAccountTypes;
	default_merchant_account: string;
	is_lite_supported: boolean;
	is_global_supported: boolean;
}

export interface KeyValuePair {
	[field: string]: string | number | unknown;
}

export interface INativeSupport extends KeyValuePair {
	key: number;
}

export interface IUpiDetails {
	profileId: string;
	upiProfileDetails: IUpiProfileDetails;
	reactivationStatus: boolean;
	initDeviceBinding: boolean;
	upiDataFetched: boolean;
	isUserPresent: boolean;
	userActivationStatus: string;
}

export interface IAppInfo {
	latitude: string;
	longitude: string;
	token: string;
	language: string;
	Authorization: string;
	Entity: string;
	device: string;
	simid: string;
	installid: string;
}
export interface ISimDetailsObject {
	sim_id: string;
	carrier_name: string;
	slot: number;
	phone: string;
	opt_type: string;
	is_active: string;
	icon_res: number;
	icon_bitmap: any;
}

export interface IHomeModalVisibility {
	accountBreakupModal: boolean;
	prePaidAccountBreakupModal: boolean;
	accountBlockedModal: boolean;
	settingsModal: boolean;
	blockingModal: boolean;
	nonBharatPeModal: boolean;
	notAcceptedQRModal: boolean;
	postpeNotAcceptedModal: boolean;
	freezeAccountModal: boolean;
	riskyAccountBlockModal: boolean;
	accountPermanenetlyBlockedModal: boolean;
	upgradeInProgressModal: boolean;
	upiIntroModal: boolean;
	upiSimModal: boolean;
	upiNoSimModal: boolean;
	disableQrModal: boolean;
	qrUpiSimBindingModal: boolean;
	qrScannerPermissionsModal: boolean;
	qrErrorModal: boolean;
	deregisterProfileAccountModal: boolean;
	permissionModal: {
		visible: boolean;
		primaryBtnText: string;
	};
	maxLimitModal: boolean;
	handleSomethingWentWrong: boolean;
}

export type IModalType = keyof IHomeModalVisibility;

export interface IUserUPIBankList {
	bankData: Array<any>;
	vpa: string;
	accountProviderId: string;
	userReferenceId: string;
}

export interface ICredAllowedType {
	dLength: string;
	CredsAllowedDType: string;
	CredsAllowedSubType: string;
	CredsAllowedType: string;
}

export interface IUserBankData {
	bank_logo: string;
	vpa: string;
	ifsc: string;
	account: string;
	bank_provider_id: string;
	aadhaarNo: string;
	name: string;
	bank_provider_name: string;
	accRefNumber: string;
	accType: string;
	mmid: string;
	mbeba: string;
	abeba: string;
	CredsAllowed: ICredAllowedType[];
	bankName: string;
}

export interface IUserUPIBankListNative {
	success: boolean;
	bankData: {
		accountList: Array<IUserBankData>;
		vpa: string;
		selectedBankId: string;
		payerName: string;
		accountProviderId: string;
	};
}
export interface IAllBanks {
	alias: string;
	bankCode: string;
	displayName: string;
	ifsc: string;
	imageUrl: string;
	supported: boolean;
}

export interface IAllBanksData {
	data: Array<IAllBanks>;
}

export type IDispatcherType = any;

export interface IError {
	name: string;
	message: string;
	code: string;
	stack: string;
	data?: unknown;
}

export interface ISampleResponse {
	message: string;
	api_msg?: string;
	data?: unknown;
	status_code?: string;
}
export interface IInitialState {
	loading: boolean;
	error: string;
	data: unknown;
}

export const INITIAL_STATE = (): IInitialState => ({
	loading: false,
	error: '',
	data: {},
});

export interface IPaymentModesResponse {
	id: number;
	displayName: string;
	code: string;
	icon: string;
	amount: string;
	description: string;
	recommended: boolean;
	enabled: boolean;
	options: any;
}

export interface ISendPaymentModesResponse {
	amount: number;
	beneficiaryName: string;
	status: string;
	currency: string;
	orderId: string;
	paymentURI: string;
	upiIntent: string;
}

interface IACTION<T = unknown> {
	type: string | symbol;
	payload: T;
}
export interface IAPI_ACTION<T = unknown> extends IACTION<T> {
	meta: unknown;
	error: {
		name: string;
		message: string;
		stack: string;
	};
}

export interface IPaymentStatusResponse {
	amount: number;
	beneficiaryName: string;
	status: string;
	currency: string;
	orderId: string;
	paymentURI: string;
	upiIntent?: string;
	redirectURI?: string;
	paymentStatus: string;
}

export interface IGenerateOtpResponse {
	statusCode: string;
	message: string;
	data: any;
}

export interface rzpCardInfoData {
	country: string;
	iin: string;
	issuer: string;
	issuer_name: string;
	message_type: string;
	network: string;
	sub_type: string;
	type: string;
}

export interface rzpCardInfoResponse {
	statusCode: string;
	message: string;
	data: rzpCardInfoData;
}

export enum IUpiComplaintStatus {
	OPEN = 'OPEN',
	CLOSED = 'CLOSED',
}

export interface IUpiComplaintDetail {
	upi_complaint_id: string;
	registered_date: string;
	org_txn_status: string;
	complaint_ref_no: string;
	transaction_id: string;
	remarks: string;
	dispute_status: string;
	status: IUpiComplaintStatus;
	cust_ref_no: string;
	note: string;
	upi_complaints_reason: string;
	created_at: string;
	updated_at: string;
	payee_name: string;
	amount: string;
	txn_date: string;
	txn_message: string;
}

export interface IMandateCollectRequest {
	created_at: string;
	updated_at: string;
	original_transaction_id: string;
	amount: string;
	expire_after: string;
	status: string;
	txn_type: string;
	sub_type: string;
	transaction_id: string;
	remarks: string;
	payer_details: {
		name: string;
		vpa: string;
		account_number: string;
		ifsc: string;
		bank_name: string;
		bank_logo: string;
	};
	payee_details: {
		name: string;
		vpa: string;
		account_number: string;
		ifsc: string;
		bank_name: string;
		bank_logo: string;
	};
	is_merchant_enabled: string;
	delegate_details: {
		secondary_vpa: string;
		secondary_name: string;
		delegate_type: string;
	};
}

export interface IPayerPayeeDetails {
	name: any;
	vpa: string;
	account_number: string;
	ifsc: string;
	bank_name: string;
	bank_logo: any;
	payee_logo: string;
}

export interface IPaymentRequestData {
	scrollY: number;
	scrollPosition: number;
	page_no: number;
	total_pages: number;
	page_size: number;
}

export interface ICollectRequest {
	collect_transactions: Array<ICollectRequestDetails>;
	page_no: number;
	total_pages: number;
	page_size: number;
}

export interface ICollectRequestDetails {
	expire_after: string;
	transaction_id: string;
	amount: string;
	original_transaction_id: string;
	created_at: string;
	is_merchant_enabled: boolean;
	payer_details: IPayerPayeeDetails;
	updated_at: string;
	txn_type: string;
	sub_type: string;
	payee_details: IPayerPayeeDetails;
	status: string;
}

export interface IApproveToPayTab {
	paymentRequestItem: ICollectRequestDetails[] | undefined;
	transactionLoading: boolean;
	reloadTransactions: () => void;
}

export interface IUserData {
	user_banks: IUserBank[];
	mobile: string;
	profile_id: string;
	user_status: string;
	auto_pay_active: false;
}
